/**
 * Amenity names that carry follow-up details in the editor (same matching the Amenities page uses
 * to decide when to ask for pool size, parking details or the flexible check-in type).
 */
const norm = (name: string): string => String(name || '').toLowerCase().trim();

/** Private pool, shared pool, swimming pool, plunge pool… (not jacuzzi / hot tub). */
export const isPoolAmenityName = (name: string): boolean => {
  const n = norm(name);
  if (!n || n.includes('jacuzzi')) return false;
  if (n.includes('hot tub') || n.includes('hot-tub') || n.includes('hottub')) return false;
  return n.includes('pool') || n.includes('swimming') || n.includes('plunge');
};

export const isParkingAmenityName = (name: string): boolean => {
  const n = norm(name);
  return n.includes('parking') || n.includes('car park') || n.includes('carpark');
};

/** "Flexi Checkin/Out", "Flexible check-in", … */
export const isFlexibleCheckinAmenityName = (name: string): boolean => {
  const n = norm(name);
  if (!(n.includes('flexi') || n.includes('flexible'))) return false;
  return (
    n.includes('checkin') ||
    n.includes('check-in') ||
    n.includes('check in') ||
    n.includes('checkout') ||
    n.includes('check-out') ||
    n.includes('check out') ||
    n.includes('check/out')
  );
};
